module.exports = __webpack_public_path__ + "media/svgs/Pfeil-Kreis_Icon-4b53c9c7fce250f3804f5425ff325420.svg";